import { render, staticRenderFns } from "./QualificationLevelBars.vue?vue&type=template&id=fa82421e&scoped=true"
import script from "./QualificationLevelBars.vue?vue&type=script&lang=ts"
export * from "./QualificationLevelBars.vue?vue&type=script&lang=ts"
import style0 from "./QualificationLevelBars.vue?vue&type=style&index=0&id=fa82421e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa82421e",
  null
  
)

export default component.exports